// @flow
import I18n from 'I18n'

const I18nLocal = I18n.common.errorCode

export default (code: number, ...params?: any) => {
  switch (code) {
    case 70100:
      return I18n.formatString(I18nLocal.alreadyExist, ...params)
    case 70106:
      return I18n.formatString(I18nLocal.clientPhoneWrong)
    case 70110:
      return I18n.formatString(I18nLocal.clientPhoneWrong)
    default:
      return I18nLocal.somethingError
  }
}
